<template>
    <HXContentCard title="CARGA MASIVA PERSONAS" :toBack="{ name: 'persona' }">


        <div class="container mt-4">
            <div>
                <div class="header-section">
                    <span class="h2">
                        <i class="fas fa-exclamation-circle mr-2"></i>
                        Instrucciones para la carga masiva de personas</span>
                </div>
                <p class="h4 mt-3 mb-5">Para cargar las personas de forma masiva, por favor seleccione el país,
                    descargue la plantilla de
                    Excel, complétela con la información requerida y luego súbala utilizando el siguiente cuadro de
                    carga:
                </p>
            </div>
            <div>
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <div class="col-3 m-0 p-0">
                        <label class="font-weight-bold mr-2 h4">Seleccione el país:</label>
                        <b-form-select v-model="paisSeleccionado" :options="listadoPaises" text-field="descripcion"
                            value-field="descripcion"></b-form-select>
                    </div>
                    <vs-button @click="descargarPlantilla" class="btn btn-success">
                        <i class="fa-solid fa-file-excel mr-2"></i>
                        Descargar Plantilla
                    </vs-button>
                </div>
                <DropFile
                    :fileTypes="['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']"
                    @handleFileData="subirArchivo" @fileRemoved="removerArchivo"></DropFile>
            </div>

            <div class="errores-container" v-if="totalErrores > 0">
                <div class="header-section mb-4">
                    <h2 class="text-danger">
                        <i class="fas fa-exclamation-circle mr-2"></i>
                        Errores Encontrados
                    </h2>
                    <p class="">Se encontraron {{ totalErrores }} error(es) en la carga del archivo.</p>
                </div>

                <b-card no-body class="shadow-sm">
                    <b-card v-for="(grupo, linea) in erroresAgrupados" :key="linea" class="mb-3">
                        <b-card-header header-tag="header" class="p-0" role="tab">
                            <b-button v-b-toggle="`collapse-linea-${linea}`" variant="link" class="collapse-button">
                                <div class="d-flex justify-content-between align-items-center w-100">
                                    <div class="linea-info">
                                        <span class="badge badge-danger mr-3">{{ linea == 0 ? 'múltiples líneas' :
                                            'Línea excel ' + linea }}</span>
                                        <span class="error-count text-danger">
                                            {{ grupo.length }} error{{ grupo.length > 1 ? 'es' : '' }}
                                        </span>
                                    </div>
                                    <i class="fas fa-chevron-down chevron-icon"></i>
                                </div>
                            </b-button>
                        </b-card-header>
                        <b-collapse :id="`collapse-linea-${linea}`" class="mt-2">

                            <b-card-body>
                                <div class="errores-list">
                                    <div v-for="(err, idx) in grupo" :key="idx" class="error-item mb-3">

                                        <div class="error-header">
                                            <h6 class="text-danger mb-1">
                                                <i class="fas fa-circle-xmark mr-2"></i>
                                                {{ err.error }}
                                            </h6>
                                            <p class=" mb-2">{{ err.resumen }}</p>
                                        </div>

                                        <div v-if="err.valoresDisponibles?.length">
                                            <p class="small font-weight-bold text-secondary mb-2">
                                                Valores disponibles para registrar:
                                            </p>

                                            <div class="valores-tags">

                                                <b-badge v-for="(valor, vidx) in err.valoresDisponibles" :key="vidx"
                                                    variant="secundary" class="mr-2 mb-2">
                                                    {{ valor }}
                                                </b-badge>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </b-card-body>

                        </b-collapse>

                    </b-card>

                </b-card>
            </div>

            <div class="errores-container" v-else-if="totalRegistrosCargados > 0 || valoresRepetidos.length > 0">
                <div class="header-section mb-4" v-if="personasCargadas.length > 0">
                    <h2 class="text-success">
                        <i class="fa-solid fa-circle-check mr-2"></i>
                        Valores Registrados
                    </h2>
                    <p class="h4">Se registraron correctamente {{ totalRegistrosCargados }} personas en la carga del
                        archivo.</p>
                </div>

                <b-card no-body class="shadow-sm" v-if="personasCargadas.length > 0">
                    <exportExcel v-if="personasCargadas.length > 0" :headers="exportarValoresCargados"
                        :items="personasCargadas" class="d-flex justify-content-end" />
                    <table id="datatable_personasCargadas"
                        class="table table-bordered table-responsive-md table-striped text-center">
                        <thead>
                            <tr>
                                <th v-for="item in exportarValoresCargados" :key="item.key">{{item.header}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in personasCargadas" :key="item.id">
                                <td>{{ item.numeroDocumento }}</td>
                                <td>{{ item.nombres }}</td>
                                <td>{{ item.apellidos }}</td>
                                <td>{{ item.correo }}</td>
                            </tr>
                        </tbody>
                    </table>



                </b-card>

                <div class="header-section mb-4" v-if="valoresRepetidos.length > 0">
                    <h2 class="text-warning">
                        <i class="fas fa-exclamation-circle mr-2"></i>
                        Valores Duplicados
                    </h2>
                    <p class="h4">Se encontraron {{ totalPersonasDuplicadas }} datos ya creadas en la carga del
                        archivo.</p>
                </div>
                <b-card v-if="valoresRepetidos.length > 0">
                    <exportExcel v-if="valoresRepetidos.length > 0" :headers="exportarValoresRepetidos"
                        :items="valoresRepetidos" class="d-flex justify-content-end" />
                    <table id="datatable_personasDuplicadas"
                        class="table table-bordered table-responsive-md table-striped text-center">
                        <thead>
                            <tr>
                                <th v-for="item in exportarValoresRepetidos" :key="item.key">{{ item.header }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in valoresRepetidos" :key="item.id">
                                <td>{{ item.numeroDocumento }}</td>
                                <td>{{ item.campoDuplicado }}</td>
                                <td>{{ item.valorDuplicado }}</td>
                                <td>{{ item.linea }}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
            </div>
        </div>





    </HXContentCard>
</template>
<script>
import DropFile from '../../../components/helexium/DropFileBasic.vue';
import Swal from 'sweetalert2';
import exportExcel from '../../../components/exportExcel/exportExcel.vue';
export default {
    name: "Persona_cargaMasiva",
    components: {
        DropFile,
        exportExcel
    },
    data() {
        return {
            persona: null,

            archivoCarga: null,
            errores: [],
            personasCargadas: [],
            valoresRepetidos: [],

            listadoPaises: [],
            paisSeleccionado: "Colombia",

            exportarValoresCargados: [
                { header: 'Número Documento', key: 'numeroDocumento' },
                { header: 'Nombres', key: 'nombres' },
                { header: 'Apellidos', key: 'apellidos' },
                { header: 'Correo', key: 'correo' }
            ],
            exportarValoresRepetidos: [
                { header: 'Número Documento', key: 'numeroDocumento' },
                { header: 'Campo Duplicado', key: 'campoDuplicado' },
                { header: 'Valor Duplicado', key: 'valorDuplicado' },
                { header: 'Linea Excel', key: 'linea' }
            ],
        }
    },
    async mounted() {
        this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
        console.log("Persona: ", this.persona);

        await this.listarPaises();
    },
    methods: {
        async subirArchivo(data) {
            // Lógica para subir el archivo
            this.destruirDataTable("#datatable_personasCargadas");
            this.destruirDataTable("#datatable_personasDuplicadas");

            Swal.fire({
                title: "Cargando y validando información...",
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });
            console.log("Cargando el archivo", data);

            this.archivoCarga = data;
            const formData = new FormData();

            formData.append("archivoExcel", this.archivoCarga);

            try {
                let peticion = await this.$store.dispatch("hl_post_file", {
                    path: `CargaMasivaPersonas/LeerExcel/${this.persona.empresa.id}/${this.paisSeleccionado}`,
                    data: formData,
                });
                let peticionParseada = await peticion.json();
                console.log("La respuesta de la carga de archivos es: ", peticionParseada);
                this.errores = peticionParseada.errores || [];

                if (peticionParseada.errores && peticionParseada.errores.length > 0) {
                    Swal.fire({
                        icon: "error",
                        title: "Errores encontrados",
                        text: "Se encontraron errores en la carga. Por favor revíselos.",
                    });
                    this.personasCargadas = [];
                } else {

                    if (peticionParseada.valoresRepetidos &&
                        peticionParseada.valoresRepetidos.length > 0) {
                        Swal.fire({
                            icon: "warning",
                            title: "Completado con duplicados",
                            text: "Proceso completado, pero se encontraron personas ya creadas, validar listado.",
                        });

                        this.valoresRepetidos = peticionParseada.valoresRepetidos || [];
                    } else {
                        Swal.fire({
                            icon: "success",
                            title: "Listo",
                            text: "Proceso completado"
                        });
                    }

                    this.personasCargadas = peticionParseada.personasValidasMPersona || 0;

                }

            }
            catch (error) {
                let errorParseado;
                console.error("Error al subir el archivo:", errorParseado);
            }
        },
        async listarPaises() {
            let paises = await this.$store.dispatch("hl_get", {
                path: "Pais/all",
            });

            this.listadoPaises = paises;
        },
        async descargarPlantilla() {

            try {
                let archivo = await this.$store.dispatch("hl_get_file", {
                    path: `CargaMasivaPersonas/DescargarPlantilla`,
                    responseType: "blob",
                });
                const blob = new Blob([archivo], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                }); // Tipo de archivo Excel
                const link = document.createElement("a");

                // Creamos una URL para el archivo y la asignamos al enlace
                const url = window.URL.createObjectURL(blob);
                link.href = url;
                link.download = "PlantillaCargaMasiva.xlsx";
                document.body.appendChild(link);

                // Simulamos el click para forzar la descarga
                link.click();

                // Limpieza de URL y enlace
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.log("Hubo un error al generar la plantilla", error);
            }
        },



        initDataTable(dataTableId) {
            if (window.$.fn.DataTable.isDataTable(dataTableId)) {
                window.$(dataTableId).DataTable().destroy();
            }

            return window.$(dataTableId).DataTable({
                language: {
                    url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
                }
            });
        },
        destruirDataTable(dataTableId) {
            if (window.$.fn.DataTable.isDataTable(dataTableId)) {
                window.$(dataTableId).DataTable().destroy();
            }
        },
        removerArchivo() {
            this.archivoCarga = null;
            this.errores = [];
            this.personasCargadas = [];
            this.destruirDataTable("#datatable_personasCargadas");
            this.destruirDataTable("#datatable_personasDuplicadas");
        },

    },

    computed: {
        erroresAgrupados() {
            const resultado = {};

            for (const err of this.errores) {
                const linea = err.linea;

                if (!resultado[linea]) {
                    resultado[linea] = [];
                }

                resultado[linea].push(err);
            }

            return resultado;

        },
        totalErrores() {
            return this.errores.length;
        },
        totalRegistrosCargados() {
            return this.personasCargadas.length;
        },
        totalPersonasDuplicadas() {
            return this.valoresRepetidos.length;
        }

    },
    watch: {
        totalRegistrosCargados(newVal) {
            if (newVal > 0) {
                this.$nextTick(() => {
                    this.initDataTable("#datatable_personasCargadas");
                });
            }
        },
        totalPersonasDuplicadas(newVal) {
            if (newVal > 0) {
                this.$nextTick(() => {
                    this.initDataTable("#datatable_personasDuplicadas");
                });
            }
        }
    }

};

</script>


<style scoped>
.errores-container {
    padding: 20px;
    border-radius: 8px;
}

.header-section {
    border-bottom: 2px solid #e9ecef;
    padding-bottom: 20px;
}

.header-section h2 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 8px;
}

.collapse-item {
    margin-bottom: 16px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.collapse-item:hover {
    border-color: #dc3545;
    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.1);
}

.collapse-button {
    display: block;
    width: 100%;
    padding: 16px;
    border: none;
    text-align: left;
}

.collapse-button:hover {
    text-decoration: none;
}

.collapse-button:focus {
    box-shadow: none;
    outline: none;
}

.linea-info {
    display: flex;
    align-items: center;
}

.error-count {
    font-size: 14px;
}

.chevron-icon {
    color: #dc3545;
    font-size: 18px;
    transition: transform 0.3s ease;
}

.collapse-button.collapsed .chevron-icon {
    transform: rotate(-90deg);
}

.collapse-body {
    border-top: 1px solid #dee2e6;
}

.error-item {
    padding: 12px;
    border-left: 3px solid #dc3545;
    border-radius: 4px;
}

.error-item:last-child {
    margin-bottom: 0 !important;
}

.error-header h6 {
    font-size: 14px;
    font-weight: 600;
}

.valores-disponibles {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #dee2e6;
}

.valores-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.valores-tags .badge {
    padding: 6px 12px;
    font-size: 12px;
    border: 1px solid #dee2e6;
}
</style>